module.exports = __webpack_public_path__ + "img/payments.dbf68f12.svg";